import { createContext } from 'react'

/**
 * Whether something is running that a page reload would destroy.
 *
 * Only uploads and order submissions qualify: unsent chunks are held in this
 * tab, so reloading mid-upload abandons the work with nothing to resume from.
 * Watching jobs does not count -- the GPU carries on regardless and the queue
 * lives on the server.
 */
export interface WorkInFlightValue {
  busy: boolean
  /** Called by whatever owns the work; safe to call with the same value twice. */
  setBusy: (busy: boolean) => void
}

export const WorkInFlightContext = createContext<WorkInFlightValue>({
  busy: false,
  setBusy: () => undefined,
})
